import { NotificationDetail } from '@aibees/shared/features/notifications/components/notification-detail';
import { notificationBadgeInfoMap } from '@aibees/shared/features/notifications/config';
import { classnames } from '@aibees/shared/utils';
import { LinearProgress } from '@mui/material';
import { useSnackbar } from 'notistack';
import { forwardRef } from 'react';
import { useSnackbarHoverProgressTimer } from '../../hooks/use-snackbar-hover-progress-timer';
import * as Styled from './styles';
import type { WarningSnackbarProps as Props } from './types';

export const WarningSnackbar = forwardRef<HTMLDivElement, Props>(
  (props, ref) => {
    const {
      id,
      message,
      title,
      className,
      icon,
      iconVariant,
      variant,
      autoHideDuration,
      ...other
    } = props;

    const { closeSnackbar } = useSnackbar();
    const { handleMouseEnter, handleMouseLeave, progress } =
      useSnackbarHoverProgressTimer(autoHideDuration, () => {
        closeSnackbar(id);
      });

    return (
      <Styled.Wrapper
        className={classnames(className)}
        ref={ref}
        role="alert"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        {...other}
      >
        <Styled.Card variant="outlined">
          <NotificationDetail
            body={message}
            badgeInfo={notificationBadgeInfoMap.FAILED}
            icon={icon || 'questionMark'}
            title={title || ''}
            notificationKey={id}
            progressbar={
              <LinearProgress
                sx={{ width: '100%' }}
                variant="determinate"
                value={progress}
              />
            }
          />
        </Styled.Card>
      </Styled.Wrapper>
    );
  }
);
